import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import NavResponsive from "../../Components/FormElements/NavResponsive";
import IconBack from "../../Resources/svg/Icons/IconBack";
import BreadCrumbs from "../BreadCrumbs";
import Loading from "../../Components/loading";
import FormTitle from "../../Components/FormElements/FormTitle";
import Footer from "../../Components/Footer";
import AlertNotifications from "../../Components/FormElements/AlertNotifications";
import IconMoney from "../../Resources/svg/Icons/IconMoney";
import IconHolder from "../../Resources/svg/Icons/IconHolder";
import ModalEditRem from "./FormElements/ModalEditRem";
import { useDispatch } from "react-redux";
import {
  sideActionsRV,
  typeDocumentListAsInsured,
} from "../../Utils/constants";
import { getDocumentLabel, transformDate } from "../../Utils/utils";
import { modalAside } from "../../Store/simulate/actions";
import { useLocation } from "react-router-dom";
import Flags from "../../Components/FormElements/Flags";
import { formatNumber, handleState } from "../../Utils/utils";
import { ComparativeIcon } from "../../Components/FormElements/CardAprobar";
import { getTitleCase } from "../../Utils/simulaciones/simulaciones";
import ModalSideRV from "./FormElements/ModalSideRV";
import { API } from "aws-amplify";
import {
  benefiType,
  genderList,
  foundType,
  EESScobertura,
  typeMoneyDescription,
  haveCoverage,
  afpFinrisk,
} from "../../Utils/constants";
import { CardBeneficiary } from "../../Components/CardBeneficiary";
import { CardModality } from "../../Components/CardModality";

export const DetailPageRV = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const [data, setData] = useState(location.state);
  const affiliate = data && data.afiliado ? data.afiliado : null;
  const beneficiaries = data && data.beneficiario ? data.beneficiario : null;
  const fund = data && data.fondo ? data.fondo : null;
  const [loadingState, setLoadingState] = useState(false);
  const modalities = data && data.producto ? data.producto : null;
  const {
    nroOperacion,
    CUSPP,
    tasaRPyRT,
    estado,
    tipoCambio,
    fechaEnvio,
    fechaCargaXML,
    fechaDevengue,
    fechaCierre,
    remuneracionPromedio,
    necesitaRemuneracionPromedio,
    fondo,
    tipoBeneficio,
    afiliado,
    tipoFondo,
  } = data || {};
  const codAFP: number = data && data.AFP;

  const afpList: any = afpFinrisk;
  const genderListRV: any = genderList;
  const haveCoverageList: any = haveCoverage;
  const EESScoberturaList: any = EESScobertura;
  const moneyTypeDescriptionList: any = typeMoneyDescription;
  const foundTypeList: any = foundType;

  const [selectedBeneficiary, setSelectedBeneficiary] = useState({});
  const [selectedModality, setSelectedModality] = useState();
  const [openModalEditRem, setOpenModalEditRem] = useState(false);
  const [activeActionSideQuote, setActiveActionSideQuote] = useState<
    string | null
  >(null);

  const codeRetirement = ["A", "B", "F", "G", "H", "I", "M", "N", "O", "P"];

  const getBenefitType = (code: string, invalidez?: string): string => {
    if (codeRetirement.includes(code)) return benefiType["J"];
    else if (code === "C") {
      if (invalidez === "T") return benefiType["IT"];
      else if (invalidez === "P") return benefiType["IP"];
      else return "";
    } else if (code === "D") return benefiType["S"];
    else return "";
  };

  const navigationPrev = () => {
    history.push("/cotizaciones", { from: history.location.pathname });
  };

  const actionSideQuote = (action: string) => {
    if (
      [
        "DETALLE_MODALIDAD",
        "MEJORAR_MODALIDAD",
        "RECALCULAR_MODALIDAD",
        "ACTUALIZAR_ASEGURADO",
        "ACTUALIZAR_BENEFICIARIO",
      ].includes(action)
    ) {
      dispatch(modalAside(true));
      setActiveActionSideQuote(action);
    }
  };

  const getQuotes = async () => {
    setLoadingState(true);
    const endpoint = "/solicitud/listar";
    const req: string = localStorage.getItem("REQUEST_RV") || "";

    const params = JSON.parse(req);
    params.filter = params.filterRV;
    delete params["filterRV"];
    const requestBody = { payload: params };

    const response = await API.post(`api-vitalicias`, endpoint, {
      body: requestBody,
    });

    const { data: dataResponse } = response.payload;
    if (dataResponse) {
      setLoadingState(false);
    }
    const selectedRequest = dataResponse.find(
      (el: any) => el.nroOperacion === (data && data.nroOperacion)
    );
    if (selectedRequest) {
      if (data && data.modalidadGanada && !selectedRequest.modalidadGanada) {
        selectedRequest.modalidadGanada = data.modalidadGanada;
      }
      setData(selectedRequest);
    }
  };

  const doc: any = typeDocumentListAsInsured.find(
    (document) =>
      document.value == (affiliate && (affiliate.tipoDoc || affiliate.TipoDoc))
  );

  const indexPosition = () => {
    const modalityWin = data && data.modalidadGanada && data.modalidadGanada.id;
    if (modalities && modalities.length > 0 && modalityWin) {
      const index = modalities.findIndex(
        (modality: any) => modality.id === modalityWin
      );
      if (index !== -1) {
        return index;
      }
    }
    return 0;
  };

  if (!data) {
    return <Loading />;
  }

  return (
    <>
      <div className="wrap">
        <NavResponsive
          position={0}
          title={"Detalle de solicitud"}
          hidden={true}
          justBack={true}
        />
        <div className="content-box d-flex">
          <div className="nav-case">
            <BreadCrumbs
              rutas={[{ link: "Cotizaciones" }, { link: "Detalle" }]}
            />
            <div className="back-responsive">
              <div className="back-responsive__box">
                <IconBack
                  className="nav-case__back"
                  onClick={() => history.push(-1)}
                />
                <div className="back-responsive__text">Volver</div>
              </div>
            </div>
            <div className="nav-case__routing">
              <IconBack className="nav-case__back" onClick={navigationPrev} />
              <div className="nav-case__title">{"Detalle de solicitud"}</div>
            </div>
          </div>
          <div className="form-register approve-quote">
            <FormTitle title={`Solicitud N° ${nroOperacion}`} />
            {/* Card datos Solicitud*/}
            <div className={"card-verify " + `${""}`}>
              <div className="card-verify__header">
                <IconMoney title={"DATOS DE SOLICITUD"} />
                <div className="card-verify__title">{"DATOS DE SOLICITUD"}</div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Estado: </div>
                <div className="card-verify__data">
                  <div className="flag-state-info">
                    <Flags
                      variant={estado}
                      widthreprom={necesitaRemuneracionPromedio}
                    >
                      {handleState(estado, necesitaRemuneracionPromedio)}
                    </Flags>
                  </div>
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">CUSPP: </div>
                <div className="card-verify__data">{CUSPP}</div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">AFP: </div>
                <div className="card-verify__data">{afpList[codAFP]} </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Prestación: </div>
                <div className="card-verify__data">
                  {getBenefitType(
                    tipoBeneficio,
                    afiliado && afiliado.gradoInvalidez
                  )}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Tipo fondo: </div>
                <div className="card-verify__data">
                  {foundTypeList[tipoFondo]}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Tasa RT: </div>
                <div className="card-verify__data">{tasaRPyRT}%</div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">T.C. Afp: </div>
                <div className="card-verify__data">{tipoCambio}</div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">F. Carga: </div>
                <div className="card-verify__data">
                  {transformDate(fechaCargaXML)}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Fec. Dev. Orig.: </div>
                <div className="card-verify__data">
                  {transformDate(fechaDevengue)}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Fecha Cierre: </div>
                <div className="card-verify__data">
                  {transformDate(fechaCierre)}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Fecha Envío: </div>
                <div className="card-verify__data">
                  {transformDate(fechaEnvio)}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Cobertura: </div>
                <div className="card-verify__data">
                  {haveCoverageList[fondo && fondo.tieneCobertura]}
                </div>
              </div>
              {fondo && fondo.EESScobertura !== 0 && (
                <div className="card-verify__body">
                  <div className="card-verify__quote">Cia. Seguros Cob.: </div>
                  <div className="card-verify__data">
                    {EESScoberturaList[fondo && fondo.EESScobertura]}
                  </div>
                </div>
              )}
            </div>
            {/* Card datos Asegurado */}
            <div className={"card-verify " + `${""}`}>
              <div className="card-verify__header">
                <IconHolder title={"DATOS DEL ASEGURADO"} />
                <div className="card-verify__title">
                  {"DATOS DEL ASEGURADO"}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Nombres: </div>
                <div className="card-verify__data">
                  {getTitleCase(
                    `${(affiliate && affiliate.primerNombre) || ""} ${
                      affiliate && affiliate.segundoNombre
                        ? affiliate.segundoNombre
                        : ""
                    }`
                  )}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Apellidos: </div>
                <div className="card-verify__data">
                  {getTitleCase(
                    `${(affiliate && affiliate.apellidoPaterno) || ""} ${(affiliate && affiliate.apellidoMaterno) || ""}`
                  )}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Tipo Doc.: </div>
                <div className="card-verify__data">{doc && doc.name}</div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Nro. Doc.: </div>
                <div className="card-verify__data">
                  {affiliate && affiliate.nroDoc}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Fecha Nac.: </div>
                <div className="card-verify__data">
                  {affiliate && transformDate(affiliate.fechaNacimiento)}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Genero: </div>
                <div className="card-verify__data">
                  {genderListRV[affiliate && affiliate.genero]}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Rem. Prom.: </div>
                <div className="card-verify__data">{remuneracionPromedio}</div>
              </div>
              {affiliate && affiliate.tipoDocumento && (
                <>
                  <div className="card-verify__body">
                    <div className="card-verify__quote">Tipo de Documento:</div>
                    <div className="card-verify__data">
                      {getDocumentLabel(affiliate.tipoDocumento)}
                    </div>
                  </div>
                </>
              )}
              {affiliate && affiliate.numeroDocumento && (
                <>
                  <div className="card-verify__body">
                    <div className="card-verify__quote">
                      Número de Documento:
                    </div>
                    <div className="card-verify__data">
                      {affiliate.numeroDocumento}
                    </div>
                  </div>
                </>
              )}
              {affiliate && affiliate.telefono && (
                <>
                  <div className="card-verify__body">
                    <div className="card-verify__quote">Celular:</div>
                    <div className="card-verify__data">
                      {affiliate.telefono}
                    </div>
                  </div>
                </>
              )}
              {affiliate && affiliate.correoElectronico && (
                <>
                  <div className="card-verify__body">
                    <div className="card-verify__quote">Email:</div>
                    <div className="card-verify__data">
                      {affiliate.correoElectronico}
                    </div>
                  </div>
                </>
              )}
              {affiliate && affiliate.ubigeo && (
                <>
                  <div className="card-verify__body">
                    <div className="card-verify__quote">Departamento:</div>
                    <div className="card-verify__data">
                      {affiliate.departamento}
                    </div>
                  </div>
                  <div className="card-verify__body">
                    <div className="card-verify__quote">Provincia:</div>
                    <div className="card-verify__data">
                      {affiliate.provincia}
                    </div>
                  </div>
                  <div className="card-verify__body">
                    <div className="card-verify__quote">Distrito:</div>
                    <div className="card-verify__data">
                      {affiliate.distrito}
                    </div>
                  </div>
                </>
              )}
              {affiliate && affiliate.direccion && (
                <>
                  <div className="card-verify__body">
                    <div className="card-verify__quote">Dirección:</div>
                    <div className="card-verify__data">
                      {affiliate.direccion}
                    </div>
                  </div>
                </>
              )}
              {affiliate && affiliate.referencia && (
                <>
                  <div className="card-verify__body">
                    <div className="card-verify__quote">Referencia:</div>
                    <div className="card-verify__data">
                      {affiliate.referencia}
                    </div>
                  </div>
                </>
              )}
              <div className="clientForm__beneficiary-box-with-icon-button">
                {estado !== "recalculado" &&
                  estado !== "ganado" &&
                  estado !== "emitida" &&
                  estado !== "anulado" && (
                    <button
                      className="btn is-secondary is-small"
                      onClick={() => setOpenModalEditRem(true)}
                    >
                      Editar Rem. Prom.
                    </button>
                  )}
                {estado !== "anulado" && (
                  <button
                    className="btn is-secondary is-small"
                    onClick={() =>
                      actionSideQuote(sideActionsRV.ACTUALIZAR_ASEGURADO)
                    }
                  >
                    Editar
                  </button>
                )}
              </div>
            </div>
            {/* Card datos Beneficiario */}
            <div className={"card-verify " + `${""}`}>
              <div className="card-verify__header">
                <ComparativeIcon title={"DATOS DE BENEFICIARIOS"} />
                <div className="card-verify__title">DATOS DE BENEFICIARIOS</div>
              </div>
              {beneficiaries &&
                beneficiaries.map((beneficiary: any, index: number) => (
                  <CardBeneficiary
                    key={index}
                    beneficiary={beneficiary}
                    cardId={index}
                    actionSideQuote={actionSideQuote}
                    state={data.estado}
                    setSelectedBeneficiary={(data: any) =>
                      setSelectedBeneficiary(data)
                    }
                  />
                ))}
            </div>
            {/* Card datos Fondo */}
            <div className={"card-verify " + `${""}`}>
              <div className="card-verify__header">
                <IconMoney title={"DATOS DEL FONDO"} />
                <div className="card-verify__title">{"DATOS DEL FONDO"}</div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Capital Pensión: </div>
                <div className="card-verify__data">
                  {fund.moneda && <>{fund.moneda}&nbsp;</>}
                  {formatNumber.new(fund.capitalPension)}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Aporte Adicional: </div>
                <div className="card-verify__data">
                  {fund.moneda && <>{fund.moneda}&nbsp;</>}
                  {formatNumber.new(fund.aporteAdicional)}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Cobertura: </div>
                <div className="card-verify__data">
                  {haveCoverageList[fund.tieneCobertura]}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Cia. Seguros Cob.: </div>
                <div className="card-verify__data">{fund.EESScobertura}</div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">CIC.: </div>
                <div className="card-verify__data">
                  {fund.moneda && <>{fund.moneda}&nbsp;</>}
                  {formatNumber.new(fund.saldoCic)}
                </div>
              </div>
              <div className="card-verify__body">
                <div className="card-verify__quote">Moneda: </div>
                <div className="card-verify__data">
                  {fund.moneda && (
                    <>{moneyTypeDescriptionList[fund.moneda]}&nbsp;</>
                  )}
                </div>
              </div>
            </div>
            {/* Card datos Modalidades */}
            {data.estado !== "anulado" && (
              <div className={"card-verify " + `${""}`}>
                <div className="card-verify__header">
                  <IconMoney title={"MODALIDADES"} />
                  <div className="card-verify__title">{"MODALIDADES"}</div>
                </div>
                {modalities &&
                data.estado !== "ganado" &&
                data.estado !== "emitida" &&
                data.estado !== "recalculado" &&
                data.estado !== "enviadoEmision" ? (
                  modalities.map((modality: any, index: number) => (
                    <CardModality
                      key={index}
                      modality={modality}
                      cardId={index}
                      actionSideQuote={actionSideQuote}
                      state={data.estado}
                      nroOperacion={data.nroOperacion}
                      respuestaECM={data.respuestaECM}
                      affiliate={affiliate}
                      setSelectedModality={(data: any) =>
                        setSelectedModality(data)
                      }
                    />
                  ))
                ) : (
                  <>
                    <CardModality
                      collapseState={false}
                      modality={{
                        modalidad:
                          data.modalidadGanada &&
                          data.modalidadGanada.datosModalidadGanada &&
                          data.modalidadGanada.datosModalidadGanada.modalidad,
                        moneda:
                          data.modalidadGanada &&
                          data.modalidadGanada.datosModalidadGanada &&
                          data.modalidadGanada.datosModalidadGanada.moneda,
                        periodoGarantizado:
                          data.modalidadGanada &&
                          data.modalidadGanada.datosModalidadGanada &&
                          data.modalidadGanada.datosModalidadGanada
                            .periodoGarantizado,
                        anosRT:
                          data.modalidadGanada &&
                          data.modalidadGanada.datosModalidadGanada &&
                          data.modalidadGanada.datosModalidadGanada.anosRT,
                        nroCotizacion:
                          data.modalidadGanada &&
                          data.modalidadGanada.datosModalidadGanada &&
                          data.modalidadGanada.datosModalidadGanada.nroCotizacion,
                        resultadoEESS:
                          data.modalidadGanada &&
                          data.modalidadGanada.datosModalidadGanada &&
                          data.modalidadGanada.datosModalidadGanada.resultadoEESS,
                        respuestaMacro:
                          data.modalidadGanada &&
                          data.modalidadGanada.respuestaMacro,
                      }}
                      cardId={
                        data.modalidadGanada &&
                        data.modalidadGanada.datosModalidadGanada &&
                        data.modalidadGanada.datosModalidadGanada.mejoraParcial &&
                        data.modalidadGanada.datosModalidadGanada.mejoraParcial.id
                          ? parseInt(
                              data.modalidadGanada.datosModalidadGanada
                                .mejoraParcial.id
                            ) - 1
                          : indexPosition()
                      }
                      state={data.estado}
                      nroOperacion={data.nroOperacion}
                      respuestaECM={data.respuestaECM}
                      actionSideQuote={actionSideQuote}
                      affiliate={affiliate}
                      beneficiaries={beneficiaries}
                      setSelectedModality={(data: any) =>
                        setSelectedModality(data)
                      }
                    />
                  </>
                )}
              </div>
            )}

            <div className="input-field"></div>
          </div>
        </div>
      </div>

      <ModalEditRem
        openModalEditRem={openModalEditRem}
        setOpenModalEditRem={setOpenModalEditRem}
        request={data}
      />

      <AlertNotifications />
      {activeActionSideQuote === sideActionsRV.DETALLE_MODALIDAD && (
        <ModalSideRV
          title={"Detalle de Modalidad"}
          selectedModality={selectedModality}
          data={data}
          sideActionsRV={sideActionsRV.DETALLE_MODALIDAD}
        />
      )}
      {activeActionSideQuote === sideActionsRV.MEJORAR_MODALIDAD && (
        <ModalSideRV
          title={"Mejorar Modalidad"}
          selectedModality={selectedModality}
          data={data}
          sideActionsRV={sideActionsRV.MEJORAR_MODALIDAD}
          handleSucessImprovements={navigationPrev}
        />
      )}
      {activeActionSideQuote === sideActionsRV.RECALCULAR_MODALIDAD && (
        <ModalSideRV
          title={"Recalcular Modalidad"}
          selectedModality={selectedModality}
          data={data}
          sideActionsRV={sideActionsRV.RECALCULAR_MODALIDAD}
          handleSucessImprovements={() => getQuotes()}
        />
      )}
      {activeActionSideQuote === sideActionsRV.ACTUALIZAR_ASEGURADO && (
        <ModalSideRV
          title={"Actualizar Asegurado"}
          subtitle="Revisa los detalles del asegurado"
          sideActionsRV={sideActionsRV.ACTUALIZAR_ASEGURADO}
          selectedAssured={{ ...data.afiliado, nroOperacion }}
          handleSucessImprovements={() => getQuotes()}
        />
      )}
      {activeActionSideQuote === sideActionsRV.ACTUALIZAR_BENEFICIARIO && (
        <ModalSideRV
          title={"Actualizar Beneficiario"}
          subtitle="Revisa los detalles del beneficiario"
          sideActionsRV={sideActionsRV.ACTUALIZAR_BENEFICIARIO}
          selectedBeneficiary={{ ...selectedBeneficiary, nroOperacion }}
          handleSucessImprovements={() => getQuotes()}
        />
      )}
      <Footer />
      {loadingState && <Loading />}
    </>
  );
};
